import createNamedWrapperReducer from "../../wrapperReducer";
import { combineReducers } from "redux";
import { IInsiderReducerType } from "@domains/features/Markets/Equity/entities/iInsiderTradingSast";
import insiderTrading from "./insiderTradingSast";
export default combineReducers({
    insiderTrading: createNamedWrapperReducer(insiderTrading, IInsiderReducerType.INSIDER_TRADING),
    substantial: createNamedWrapperReducer(insiderTrading, IInsiderReducerType.SUBSTANTIAL),
    bulkBlock: createNamedWrapperReducer(insiderTrading, IInsiderReducerType.BULK_BLOCK),
});
